module.exports = __webpack_public_path__ + "static/media/sf-trial-2-wrong.d979dc55.mp3";